import { Navigate } from "react-router-dom";
import { GlobalStore } from "../../store/global/GlobalStore";
import React, { PropsWithChildren } from "react";

export const ProtectedRoute: React.FC<PropsWithChildren> = ({ children }) => {
  const address = GlobalStore.useState(s => s.address);

  if (!address) {
    return <Navigate to="/signup" replace />;
  }

  return children;
};
